<div *ngIf="optionArr" class="select-wrap" (focusout)="onTouched()">
  <div
    class="category"
    (click)="showHideObj = !showHideObj"
    *ngIf="!countryFilter"
  >
    <h3>
      {{ title | camelCase }}
      <button
        class="button remove-filter"
        (click)="clearControl()"
        *ngIf="ultimateOutputValue.length"
      >
        {{ ultimateOutputValue.length }} &times;
      </button>
    </h3>
    <i class="icon-arrow" [ngClass]="{rotate: !showHideObj}"></i>
  </div>

  <div class="input-div" [style.display]="showHideObj ? 'block' : 'none'" #div>
    <input
      type="text"
      class="input__basic"
      [formControl]="fieldControl"
      (focus)="clearInputValue()"
    />
    <div class="option-popup" *ngIf="showPopupOption">
      <ng-container *ngFor="let option of filteredOptions | async">
        <option
          [value]="option"
          (click)="chosenOption(option)"
          *ngIf="countryFilter && fieldControl.value?.length > 1"
          [disabled]="notFound"
        >
          {{ option }}
        </option>
        <option
          [value]="option"
          (click)="chosenOption(option)"
          *ngIf="!countryFilter"
          [disabled]="notFound"
        >
          {{ option }}
        </option>
      </ng-container>
    </div>
  </div>
</div>
